import {
  EFollowType,
  FollowType,
  GroupedByData,
  GroupedByOutput,
} from '@bonhams1793/bonhams-typescript'

export function isGroupedById(
  data: GroupedByData,
  type: EFollowType
): data is GroupedByOutput {
  return FollowType.lot === type
}
